export const WorkoutBlock = ({
    block,
    removeBlock,
    updateBlock,
    exerciseList,
    getRecentMaxText,
    difficultyOptions
}) => {
    return (
        <div key={block.id} className="card p-5 bg-white rounded-3xl shadow-sm border-2 border-indigo-100 relative">
            <button onClick={() => removeBlock(block.id)} className="absolute top-4 right-4 text-slate-300 hover:text-rose-500 transition-colors">
                <span className="material-icons-round text-xl">close</span>
            </button>
            <div className="mb-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                    <span className="material-icons-round text-indigo-500">fitness_center</span>
                    <select value={block.name} onChange={
                        (e) => {
                            updateBlock(block.id, { name: e.target.value });
                        }} 
                        className="flex-1 bg-gray-50 text-slate-700 text-sm font-bold py-2 outline-none appearance-none cursor-pointer pl-4 mr-10">
                        {Array.isArray(exerciseList) && exerciseList.map((ex, idx) => <option key={idx} value={ex}>{ex}</option>)}
                    </select>
                </div>
                <p className="text-[11px] font-bold text-indigo-500 ml-1 flex items-center gap-1">
                    <span className="material-icons-round text-[14px]">insights</span>
                    {getRecentMaxText ? getRecentMaxText(block.name) : '최근 기록 안내'}
                </p>
            </div>
            <div className="space-y-4 mb-6">
                {block.sets.map((set, setIndex) => (
                    <div key={setIndex} className="flex flex-col gap-3 bg-slate-50 p-3.5 rounded-2xl border border-slate-100">
                        <div className="flex gap-2 items-center">
                            <span className="text-xs font-black text-slate-400 w-8 text-center">{setIndex + 1}</span>
                            <div className="flex-1 flex gap-2">
                                <div className="relative flex-1">
                                    <input type="number" inputMode="decimal" value={set.weight} onChange={(e) => { const newSets = [...block.sets]; newSets[setIndex].weight = e.target.value; updateBlock(block.id, { sets: newSets }); }} placeholder="무게" className="w-full bg-white text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-indigo-500 text-center" />
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">kg</span>
                                </div>
                                <div className="relative flex-1">
                                    <input type="number" inputMode="numeric" value={set.reps} onChange={(e) => { const newSets = [...block.sets]; newSets[setIndex].reps = e.target.value; updateBlock(block.id, { sets: newSets }); }} placeholder="횟수" className="w-full bg-white text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-indigo-500 text-center" />
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">회</span>
                                </div>
                            </div>
                            {block.sets.length > 1 && (
                                <button onClick={() => { const newSets = [...block.sets]; newSets.splice(setIndex, 1); updateBlock(block.id, { sets: newSets }); }} className="p-2 text-slate-300 hover:text-rose-500 transition-colors"><span className="material-icons-round text-xl">remove_circle</span></button>
                            )}
                        </div>
                        <div className="flex items-center justify-around pl-10 pr-2">
                            <span className="text-[11px] font-bold text-slate-500">난이도</span>
                            <div className="flex gap-3 bg-slate-200/50 p-1 rounded-lg">
                                {difficultyOptions.map((diff) => (
                                    <button 
                                        key={diff} 
                                        onClick={() => {
                                            const newSets = [...block.sets]; 
                                            newSets[setIndex].difficulty = diff; 
                                            updateBlock(block.id, { sets: newSets });
                                        }} 
                                        className={`px-2.5 py-1 text-[11px] font-bold rounded-md transition-all ${
                                            (set.difficulty || '보통') === diff 
                                            ? 'bg-white text-indigo-600 shadow-sm border border-slate-200/50' 
                                            : 'text-slate-400'
                                        }`}
                                    >
                                        {diff}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <button onClick={() => {
                updateBlock(block.id, { 
                    sets: [...block.sets, { weight: '', reps: '', difficulty: '보통' }] 
                });
            }} className="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-2xl text-sm font-black transition-colors flex items-center justify-center gap-1">
                <span className="material-icons-round text-sm">add</span>세트 추가
            </button>
        </div>
    );
}